import React from 'react'
import PropTypes from 'prop-types'
import {Table, Column, Cell} from 'components/Table'
import Checkbox from 'components/Checkbox'

export default class EditMappingForm extends React.Component {
  static propTypes = {
    mappings: PropTypes.array,
    onRemoveMappings: PropTypes.func.isRequired
  }

  static contextTypes = {
    permissions: PropTypes.object
  }

  constructor(props) {
    super(props)
    this.state = {
      selectedMappings: []
    }
  }

  componentWillReceiveProps(nextProps) {
    const {selectedMappings} = this.state
    this.setState({
      selectedMappings: selectedMappings.filter(mappingId =>
        nextProps.mappings.some(mapping => mapping.id === mappingId)
      )
    })
  }

  render() {
    const {mappings} = this.props
    const {selectedMappings} = this.state
    const {permissions} = this.context
    const disabled = selectedMappings.length === 0
    const hidden = !permissions.show.includes('@features/categoryMappings')

    return (
      <form className='settings-categories-view_edit-form' onSubmit={this.handleSubmit}>
        <Table data={mappings} empty='No mappings for selected category'>
          <Column header='Mappings' grow cell={data => <Cell>{data.mapping}</Cell>} />
          {!hidden ? <Column
            header='Select'
            width='100px'
            className='is-checkbox'
            cell={data => {
              return (
                <Cell className='is-checkbox'>
                  <Checkbox
                    checked={selectedMappings.includes(data.id)}
                    onChange={checked => this.onSelect(data.id, checked)}
                  />
                </Cell>
              )
            }}
          /> : null}
        </Table>
        {!hidden ? <div className='settings-categories-view_edit-form_button'>
          <button className='is-red' disabled={disabled} type='submit'>Remove Selected</button>
        </div> : null}
      </form>
    )
  }

  onSelect = (id, checked) => {
    const {selectedMappings} = this.state

    if (checked) {
      this.setState({
        selectedMappings: !selectedMappings.includes(id) ? [...selectedMappings, id] : selectedMappings
      })
    } else if (selectedMappings.includes(id)) {
      const index = selectedMappings.findIndex(mapping => mapping === id)

      this.setState({
        selectedMappings: [
          ...selectedMappings.slice(0, index),
          ...selectedMappings.slice(index + 1)
        ]
      })
    }
  }

  handleSubmit = evt => {
    evt.preventDefault()
    const {onRemoveMappings} = this.props
    const {selectedMappings} = this.state

    onRemoveMappings(selectedMappings)
  }
}



// WEBPACK FOOTER //
// ./client/views/SettingsCategoriesView/EditMappingForm.js